import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconVariogramM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11.7874C10.0917 11.7874 11.7874 10.0917 11.7874 8C11.7874 5.90828 10.0917 4.2126 8 4.2126C5.90828 4.2126 4.2126 5.90828 4.2126 8C4.2126 10.0917 5.90828 11.7874 8 11.7874ZM8 12.7874C10.644 12.7874 12.7874 10.644 12.7874 8C12.7874 5.35599 10.644 3.2126 8 3.2126C5.35599 3.2126 3.2126 5.35599 3.2126 8C3.2126 10.644 5.35599 12.7874 8 12.7874Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
    />
  </svg>
)

export const IconVariogram = createIcon({
  name: 'IconVariogram',
  l: IconVariogramM,
  m: IconVariogramM,
  s: IconVariogramM,
  xs: IconVariogramM,
})
